export const GENERATE_VALIDATION_CODE = "GENERATE_VALIDATION_CODE";
export const GENERATE_VALIDATION_CODE_RESULT = "GENERATE_VALIDATION_CODE_RESULT";
export const COMMON_TOGGLE_SIDEBAR = 'COMMON_TOGGLE_SIDEBAR';
export const COMMON_DATAVIEW_GET_DATA_REQUEST = 'COMMON_DATAVIEW_GET_DATA_REQUEST';
export const COMMON_DATAVIEW_GET_DATA_RESULT = 'COMMON_DATAVIEW_GET_DATA_RESULT';
export const COMMON_CHANGE_SELECT_LANGUAGE = 'COMMON_CHANGE_SELECT_LANGUAGE';
export const CLEAR_REDUX = 'CLEAR_REDUX';
